module.exports = __webpack_public_path__ + "img/truck.7501921e.png";